import { render } from "./QuizDetailsPanel.vue?vue&type=template&id=15cea084"
import script from "./QuizDetailsPanel.vue?vue&type=script&lang=js"
export * from "./QuizDetailsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__